import * as actionTypes from '../actions/actionTypes';

// Track concurrent requests of the same type with a counter.
// The boolean flag ('ATTENTE_REQUETE' + type) stays true until ALL concurrent
// requests of that type finish, preventing race conditions when multiple
// AffichageVue instances run simultaneously.
const debutAttente = (state, action) => {
  const countKey = '_cnt_' + action.requestType;
  const flagKey = 'ATTENTE_REQUETE' + action.requestType;
  const newCount = (state[countKey] || 0) + 1;
  return { ...state, [countKey]: newCount, [flagKey]: true };
};
const finAttente = (state, action) => {
  const countKey = '_cnt_' + action.requestType;
  const flagKey = 'ATTENTE_REQUETE' + action.requestType;
  const newCount = Math.max(0, (state[countKey] || 0) - 1);
  return { ...state, [countKey]: newCount, [flagKey]: newCount > 0 };
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.DEBUT_ATTENTE:
      return debutAttente(state, action);
    case actionTypes.FIN_ATTENTE:
      return finAttente(state, action);
    default:
      return state;
  }
};

export default reducer;
